import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAppContext } from './context/AppContext';

// Importe suas páginas e componentes
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import BarbershopPage from './pages/BarbershopPage';
import BarbershopEditPage from './pages/BarbershopEditPage';
import MyAppointmentsPage from './pages/MyAppointmensPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ProfilePage from './pages/ProfilePage';
import ContactPage from './pages/ContactPage';
import NotificationsPage from './pages/NotificationsPage';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import OwnerProfilePage from './pages/OwnerProfilePage';
import AdminLogsPage from './pages/AdminLogsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import SupportPage from './pages/SupportPage';
import SupportChatbot from './components/SupportChatbot';
// A BarbershopOwnerPage é renderizada pela BarbershopPage, mas pode ser uma rota própria se preferir

export default function App() {
  const { authLoading } = useAppContext();

  // Loading state enquanto carrega auth
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div className="font-inter antialiased">
        {/* Toast Notifications */}
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
              primary: '#4ade80',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      
      <BrowserRouter>
        <Header />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/barbershop/:id" element={<BarbershopPage />} />
          
          {/* Rotas de Autenticação */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/registro" element={<RegisterPage />} />
          <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
          
          {/* Rota Pública de Contato */}
          <Route path="/contato" element={<ContactPage />} />
          
          {/* Rota Pública de Suporte */}
          <Route path="/suporte" element={<SupportPage />} />
          
          {/* Rotas Públicas de Documentação Legal */}
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          
          {/* Rota Pública de Perfil de Dono */}
          <Route path="/owner/:ownerId" element={<OwnerProfilePage />} />
          
          {/* Rotas Protegidas */}
          <Route 
            path="/meus-agendamentos" 
            element={
              <ProtectedRoute>
                <MyAppointmentsPage />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/perfil" 
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } 
          />
          
          {/* Rota Protegida para Donos de Barbearia */}
          <Route 
            path="/barbershop/edit" 
            element={
              <ProtectedRoute requireRole="owner">
                <BarbershopEditPage />
              </ProtectedRoute>
            } 
          />
          
          {/* Rota Protegida para Admin */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requireRole="admin">
                <AdminPage />
              </ProtectedRoute>
            }
          />
          
          {/* Rota Protegida para Admin - Logs */}
          <Route 
            path="/admin/logs" 
            element={
              <ProtectedRoute requireRole="admin">
                <AdminLogsPage />
              </ProtectedRoute>
            }
          />
          
          {/* Rota Protegida para Donos - Analytics */}
          <Route 
            path="/analytics" 
            element={
              <ProtectedRoute requireRole="owner">
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />
          
          {/* Rota Protegida para Notificações */}
          <Route 
            path="/notifications" 
            element={
              <ProtectedRoute>
                <NotificationsPage />
              </ProtectedRoute>
            }
          />
          
          {/* Rota 404 - Deve ser a última */}
          <Route path="*" element={<NotFoundPage />} />
          
          {/* A BarbershopPage internamente já lida com a exibição do Owner,
              mas você também pode fazer uma rota protegida:
          <Route 
            path="/minha-barbearia" 
            element={currentUser.role === 'owner' ? <BarbershopOwnerPage /> : <Navigate to="/" />} 
          />
          */}

        </Routes>
        
        {/* Mostrar Footer em todas as páginas */}
        <Footer />
        
        {/* Chatbot de Suporte - visível em todas as páginas */}
        <SupportChatbot />

      </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}